angular.module('app').directive('trsViewHead', function(){
    return {
        scope: true,
        restrict: 'AE',
        templateUrl: './resourceCenter/directive/trsViewHead/trsViewHead_tpl.html',
        replace: true,
        link: function($scope, iElm, iAttrs, controller) {
           
        }
    };
});
